/**
 * Applies theme-configured milestone discount codes when cart subtotals unlock tiers.
 * Uses POST /cart/update.js { discount: 'CODE' } per Shopify Ajax Cart API.
 */
(function () {
  if (typeof subscribe !== 'function' || typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
    return;
  }

  const SOURCE = 'milestone-discounts';
  let syncing = false;

  function readConfig() {
    const el = document.getElementById('CartDrawer-MilestoneDiscounts');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function configuredCodeSet(config) {
    const set = new Set();
    if (!config || !Array.isArray(config.tiers)) return set;
    for (const t of config.tiers) {
      const c = t.code && String(t.code).trim();
      if (c) set.add(c.toUpperCase());
    }
    return set;
  }

  function hasConfiguredCode(config) {
    return configuredCodeSet(config).size > 0;
  }

  function normalizeDiscountList(str) {
    if (!str || typeof str !== 'string') return '';
    const parts = str
      .split(',')
      .map((c) => c.trim())
      .filter(Boolean)
      .map((c) => c.toUpperCase());
    return [...new Set(parts)].sort().join(',');
  }

  function buildDesiredDiscountPayload(cart, config) {
    let total = 0;
    if (typeof window.qualifyingSpendCentsFromCart === 'function') {
      total = window.qualifyingSpendCentsFromCart(cart);
    } else if (typeof cart.items_subtotal_price === 'number') {
      total = cart.items_subtotal_price;
    } else if (typeof cart.total_price === 'number') {
      total = cart.total_price;
    }
    const ours = configuredCodeSet(config);
    const activeMilestone = [];

    if (config && Array.isArray(config.tiers)) {
      for (const t of config.tiers) {
        const c = t.code && String(t.code).trim();
        if (!c) continue;
        const cents = Number(t.cents);
        if (Number.isFinite(cents) && total >= cents) {
          activeMilestone.push(c);
        }
      }
    }

    const preserved = [];
    if (cart.discount_codes && Array.isArray(cart.discount_codes)) {
      for (const d of cart.discount_codes) {
        if (!d || !d.applicable) continue;
        const c = String(d.code).trim();
        if (!c) continue;
        if (!ours.has(c.toUpperCase())) {
          preserved.push(c);
        }
      }
    }

    const combined = [...new Set([...activeMilestone, ...preserved])];
    return combined.join(',');
  }

  function currentCartDiscountString(cart) {
    if (!cart.discount_codes || !Array.isArray(cart.discount_codes)) return '';
    return cart.discount_codes
      .filter((d) => d && d.applicable)
      .map((d) => String(d.code).trim())
      .filter(Boolean)
      .join(',');
  }

  async function fetchCartJson() {
    const base = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
    const url = base.endsWith('.js') ? base : `${base.replace(/\/$/, '')}.js`;
    const res = await fetch(url);
    return res.json();
  }

  async function syncMilestoneDiscounts(event) {
    if (syncing) return;
    if (event && event.source === SOURCE) return;

    const config = readConfig();
    if (!config || !hasConfiguredCode(config)) return;

    let cart = event && event.cartData;
    if (!cart || (typeof cart.items_subtotal_price !== 'number' && typeof cart.total_price !== 'number')) {
      try {
        cart = await fetchCartJson();
      } catch (e) {
        return;
      }
    }

    const desired = buildDesiredDiscountPayload(cart, config);
    const current = currentCartDiscountString(cart);

    if (normalizeDiscountList(desired) === normalizeDiscountList(current)) {
      return;
    }

    syncing = true;
    try {
      const body = JSON.stringify({ discount: desired });
      const updateUrl = window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update';
      const res = await fetch(updateUrl, {
        ...fetchConfig('json'),
        body,
      });
      const updated = await res.json();
      if (!res.ok || (updated && updated.errors)) {
        return;
      }
      publish(PUB_SUB_EVENTS.cartUpdate, { source: SOURCE, cartData: updated });
    } catch (e) {
      /* ignore */
    } finally {
      syncing = false;
    }
  }

  const run = debounce((event) => {
    syncMilestoneDiscounts(event);
  }, 120);

  subscribe(PUB_SUB_EVENTS.cartUpdate, run);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => run(undefined));
  } else {
    run(undefined);
  }
})();
